import Modal from '@/components/modals/modal/modal.vue'
import dateRangeFormMixin from '@/components/mixins/date-range-form-mixin'
import emitHideMixin from '@/components/modals/mixins/emit-hide'

const getDefaultDates = (startDate) => {
  const dateFrom = startDate ? new Date(startDate) : new Date()
  const dateTo = startDate ? new Date(startDate) : new Date()
  dateTo.setHours(dateTo.getHours() + 8)
  return {
    dateFrom,
    dateTo
  }
}

export default {
  name: 'DateRangeFormModal',
  /**
   * emitHideMixin - методы hide и onHideModal
   */
  mixins: [dateRangeFormMixin, emitHideMixin],
  props: {
    dateFrom: {
      type: Date | Object
    },
    dateTo: {
      type: Date | Object
    },
    texts: {
      type: Object,
      default: () =>({
        header: 'Изменить время смены',
        description: 'Вы уверены, что хотите изменить время смены?',
        startLabel: 'Начало смены',
        endLabel: 'Окончание смены',
        btnSubmit: 'Сохранить'
      })
    }
  },
  components: {
    Modal
  },
  data() {
    return {
      form: getDefaultDates()
    }
  },
  methods: {
    show () {
      this.form.dateFrom = this.dateFrom ? this.dateFrom : new Date()
      this.form.dateTo = this.dateTo ? this.dateTo : getDefaultDates(this.form.dateFrom).dateTo
      this.$refs.modal.show()
    },
    closeDatePickers(event) {
      ['datepicker1', 'datepicker2'].forEach(key => {
        this.$refs[key].$children[0].handleClickOutSide(event)
      })
    },
    onSubmitSuccess() {
      this.$emit('submit', {
        ...this.form
      })
    }
  }
}